import { render } from "./DoctorPicker.vue?vue&type=template&id=520fa3a0&scoped=true"
import script from "./DoctorPicker.vue?vue&type=script&lang=js"
export * from "./DoctorPicker.vue?vue&type=script&lang=js"

import "./DoctorPicker.vue?vue&type=style&index=0&id=520fa3a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520fa3a0"]])

export default __exports__